module.exports = __webpack_public_path__ + "static/media/javascript2.1e29b804.png";